import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { Input } from '@/components/ui/Input';
import { validatorNip } from '@/helpers/nipValidator';

import { normalizeTaxId } from '../helpers/companyInvoice';
import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const TAX_ID_NAME = 'tax_id';

interface Props {
  name?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  lookupError?: string;
  companyDataError?: string;
}

const InputTaxId: FC<Props> = ({
  name = TAX_ID_NAME,
  disabled,
  autoFocus,
  lookupError,
  companyDataError,
}) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (v, form) => {
          if (!form.is_company) return true;
          if (!v?.trim()) return i18n.t('Uzupełnij NIP');
          return (
            validatorNip(normalizeTaxId(v))() || i18n.t('Podaj prawidłowy NIP')
          );
        },
      }}
      render={({
        field: { onBlur, onChange, ...field },
        fieldState: { error },
      }) => (
        <FormItem>
          <FormControl>
            <Input
              label={i18n.t('NIP')}
              error={lookupError ?? error?.message ?? companyDataError}
              success={
                !focused &&
                !error &&
                !lookupError &&
                !companyDataError &&
                !!field.value
              }
              inputMode="numeric"
              autoFocus={autoFocus}
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              onChange={(e) => {
                onChange(e);
                if (error) trigger(name);
              }}
              {...field}
              disabled={disabled}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputTaxId;
